import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const Signup = () => {
	const location = useLocation()
	return <Navigate to={`/${location.search}`} />
}

export default Signup
